import { styled } from '@mui/material';
import { Button, Stack, Text } from 'shell/components';

const ErrorPageLayout = ({ action, description, image, imageAlt, imageHeight, imageWidth, title }) => {
    return (
        <Root>
            <Title component={'h1'} weight={'medium'}>
                {title}
            </Title>
            <HugoImage src={image} alt={imageAlt} width={imageWidth} height={imageHeight} />
            <Stack spacing={5}>
                <Description variant={'p1'} component={'p'} weight={'medium'}>
                    {description}
                </Description>
                {action && <Action onClick={action.onClick}>{action.label}</Action>}
            </Stack>
        </Root>
    );
};

const Root = styled('main')(({ theme }) => ({
    minHeight: '100%',
    background: theme.palette.ensightful.shades[0],
    color: theme.palette.ensightful.neutral[900],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(15, 2.5, 6),
    textAlign: 'center',
    gap: theme.spacing(20),

    [theme.breakpoints.down('tablet')]: {
        paddingTop: theme.spacing(7.5),
    },
}));

const Title = styled(Text)(({ theme }) => ({
    color: theme.palette.ensightful.neutral[900],
    fontSize: '2.625rem',
    lineHeight: '3.25rem',

    [theme.breakpoints.down('tablet')]: {
        fontSize: '1.5rem',
        lineHeight: '2rem',
    },
}));

const HugoImage = styled('img')({
    display: 'block',
    objectFit: 'contain',
    maxWidth: '100%',
});

const Description = styled(Text)(({ theme }) => ({
    maxWidth: '570px',
    color: theme.palette.ensightful.neutral[700],
    lineHeight: '1.25rem',
    whiteSpace: 'pre-line',
}));

const Action = styled(Button)(({ theme }) => ({
    minHeight: '36px',
    padding: theme.spacing(2, 4),
    fontWeight: 600,
    lineHeight: '1rem',
    width: 'fit-content',
    marginInline: 'auto',
}));

export default ErrorPageLayout;
